/**
 * 日期相关的文本
 */
export default {
  dbl_date_day: 'day',
  dbl_date_day_upper: 'Day',
  dbl_date_days: 'days',
  dbl_date_day_last_current: 'Today',
  dbl_date_day_today: 'today',
  dbl_date_day_last_1: 'Yesterday',
  dbl_date_day_last_3: 'Last 3 days',
  dbl_date_day_last_7: 'Last 7 days',
  dbl_date_day_last_14: 'Last 14 days',
  dbl_date_day_last_30: 'Last 30 days',
  dbl_date_day_last: 'Last {last} days',
  dbl_date_day_last_prefix: 'Last {last} Days',
  dbl_date_day_last_prefix_1: 'Last 1 Day',
  dbl_date_day_last_prefix_current: 'Today',

  dbl_date_day_ago_current: 'Today',
  dbl_date_day_ago_1: 'Yesterday',
  dbl_date_day_ago_2: '2 days ago',
  dbl_date_day_ago_3: '3 days ago',
  dbl_date_day_ago_4: '4 days ago',
  dbl_date_day_ago: '{ago} days ago',
  dbl_date_text_day_ago: 'days ago',


  dbl_date_week: 'week',
  dbl_date_week_upper: 'Week',
  dbl_date_weeks: 'weeks',
  dbl_date_week_last_current: 'Current week',
  dbl_date_week_last_1: 'Last 1 week',
  dbl_date_week_last: 'Last {last} weeks',
  dbl_date_week_last_prefix: 'Last {last} Weeks',
  dbl_date_week_last_prefix_1: 'Last 1 Week',
  dbl_date_week_last_prefix_current: 'Current Week',
  dbl_date_week_ago_current: 'Current week',
  dbl_date_week_ago_1: 'Last week',
  dbl_date_week_ago_2: '2 weeks ago',
  dbl_date_week_ago_3: '3 weeks ago',
  dbl_date_week_ago_4: '4 weeks ago',
  dbl_date_week_ago: '{ago} weeks ago',
  dbl_date_text_week_ago: 'weeks ago',

  dbl_date_month: 'month',
  dbl_date_month_upper: 'Month',
  dbl_date_months: 'months',
  dbl_date_month_last_current: 'Current month',
  dbl_date_month_last_1: 'Last 1 month',
  dbl_date_month_last: 'Last {last} months',
  dbl_date_month_last_prefix: 'Last {last} Months',
  dbl_date_month_last_prefix_1: 'Last 1 Month',
  dbl_date_month_last_prefix_current: 'Current Month',
  dbl_date_month_ago_current: 'Current month',
  dbl_date_month_ago_1: 'Last month',
  dbl_date_month_ago_2: '2 months ago',
  dbl_date_month_ago_3: '3 months ago',
  dbl_date_month_ago_4: '4 months ago',
  dbl_date_month_ago: '{ago} months ago',
  dbl_date_text_month_ago: 'months ago',

  dbl_date_year: 'Year to date',
  dbl_date_year_prefix: 'Year To Date',
  dbl_date_from: ' (as of {from})',
  
  dbl_date_hour: 'hour',
  dbl_date_hours: 'hours',
  dbl_date_hour_now: 'Today to now',
  dbl_date_hour_current: 'Current hour',
  dbl_date_hour_last_1: 'Last 1 hour',
  dbl_date_hour_last_6: 'Last 6 hours',
  dbl_date_hour_last_12: 'Last 12 hours',
  dbl_date_hour_last_24: 'Last 24 hours',
  dbl_date_hour_last_48: 'Last 48 hours',
  dbl_date_hour_last: 'Last {last} hours',
  dbl_date_hour_ago_current: 'Current hour',
  dbl_date_hour_ago: '{ago} hours ago',
  dbl_date_text_hour_ago: 'hours ago',
  dbl_date_hour_ago_1: 'Last hour',
  dbl_date_hour_ago_2: '2 hours ago',
  dbl_date_hour_ago_3: '3 hours ago',
  dbl_date_hour_last_prefix: 'Last {last} hours',
  dbl_date_hour_last_prefix_1: 'Last 1 hour',
  dbl_date_hour_last_prefix_current: 'Current hour',
  dbl_date_ago: 'ago',
  
  // 时间对比设置 info
  dbl_time_compare_info_chart: 'The time comparison feature currently only works with line charts and event line charts.',
  dbl_time_compare_info_dashboard: 'The time comparison feature currently only works with line charts and event line charts that are within the filter\'s effective scope.',
  dbl_time_compare_title: 'Time Compare',
  dbl_time_compare_label: 'Compare Time',
  dbl_time_compare_base: 'Base Time',
  dbl_time_compare_custom_text_prefix: 'The base time',
  dbl_time_compare_custom_info: 'Based on the base time period (T), using the input value as offset units (n), calculate the comparison time period base on T-n.',
  dbl_time_compare_add_disabled: 'Up to 4 compare times are supported',
  
  // 字符串下拉选时间筛选器
  dbl_time_all: 'All Time',
  dbl_time_last_datetype: 'Last {lastCount} {dateType}',
  dbl_time_string_filter_label1: 'Time range',
  dbl_time_string_filter_label2: 'Time field',
  dbl_time_last_text: 'Last',

  dbl_date_last_custom_info: 'At least 5',
};